import { render } from "./startUpAlertSubscription.vue?vue&type=template&id=0011e5ba"
import script from "./startUpAlertSubscription.vue?vue&type=script&lang=js"
export * from "./startUpAlertSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__